// import React, { useState } from "react";


// function DateResume (props) {

//     return(
//         <div className="bg-slate-50 py-5">
//             <div className="font-bold text-2xl px-4 text-gray-600 mb-3 text-center">
//                 <p>Día del Despacho</p>
//             </div>
//             <div className="text-center text-gray-500">
//                 <p>{props.deliveryDate[1]} {props.deliveryDate[2]} de {props.deliveryDate[3]}</p>
//             </div>
//         </div>
//     )
// }

// export default DateResume;

import React from "react";

function DateResume(props) {
    return (
        <div className="mx-3 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">
            <div className="px-4 py-3 flex items-center gap-2 bg-[#fdf7ef] border-b border-gray-100">
                <svg className="w-4 h-4 text-[#0f4a4e] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                <p className="text-sm font-semibold text-[#1a1f1a]">Día de despacho</p>
            </div>
            <div className="px-4 py-3 flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-[#0f4a4e] flex flex-col items-center justify-center flex-shrink-0">
                    <span className="text-[8px] font-medium text-[#bcd4d2] uppercase tracking-wider leading-none">
                        {props.deliveryDate[1]}
                    </span>
                    <span className="text-[18px] font-bold text-white leading-none mt-0.5">
                        {props.deliveryDate[2]}
                    </span>
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-[13px] font-semibold text-[#1a1f1a] truncate">
                        {props.deliveryDate[1]} {props.deliveryDate[2]} de {props.deliveryDate[3]}
                    </p>
                    <p className="text-[11px] text-gray-400 mt-0.5">Despacho a domicilio</p>
                </div>
            </div>
        </div>
    );
}

export default DateResume;